export { default as FirstDoctorDetails } from "./firstDoctorDetails";
export { default as FirstDoctorExaminationDetails } from "./firstDoctorExaminationDetails";
export { default as JointDetentionDetails } from "./jointDetentionDetails";
export { default as JointDetentionDetailsTreatment } from "./jointDetentionDetailsTreatment";
export { default as JointHospitalRecommendations } from "./jointHospitalRecommendations";
export { default as JointPatientDetails } from "./jointPatientDetails";
export { default as SecondDoctorDetails } from "./secondDoctorDetails";
export { default as SecondDoctorExaminationDetails } from "./secondDoctorExaminationDetails";
